import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useFinalizePayment from "../../store/Mutations/organisation-useFinalizePayment";
import Loading from "../../components/Loading/Loading";

const Failed = () => {
  const params = useSearchParams();
  const token = params[0].get("token");
  const navigate = useNavigate();
  const { mutate } = useFinalizePayment({
    onSuccess: () => {
      navigate("/students?failed=true");
    },
  });
  useEffect(() => {
    if (token) {
      mutate({
        token,
        success: false,
      });
    }
  }, [mutate, token]);

  return <Loading />;
};

export default Failed;
